
import axios from 'axios';
import $ from 'jquery';
import React, { Component, useState } from 'react'
import "../../services/ApiRest";
import swal from 'sweetalert';
import { ApiUrl } from '../../services/ApiRest';
import { Alert } from 'bootstrap';
import ReactPaginate from 'react-paginate';
import Cookies from 'universal-cookie';
import "./hojasestilogestiontitulacion.css";
import { Modal, ModalHeader, ModalBody, ModalFooter, FormGroup } from 'reactstrap';


const carrerasUrl = ApiUrl + "listarcarreras" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const baseUrlPeriodos = ApiUrl + "listperiodostodos" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const urlListaEstudTipoTitulacion = ApiUrl + "listestudtipotitula" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const urlListaDocentes = ApiUrl + "listusuariosadmdocen" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const urlAsignarTutorestud = ApiUrl + "asigtutorestudtitul" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const urlListarTiposTitulacion = ApiUrl + "listartipotitul" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const urlReportDocumentoTitulacionEst = ApiUrl + "documentitulaciontipotitulestud" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const urlRespuestaDocumentos = ApiUrl + "respuestadocumentrol" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const urlListarTiposCalificacionesHab = ApiUrl + "listartipocalificacionhab" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const urlIngresarCalifiTitulaEstudiante = ApiUrl + "ingresarcaliftitulestud" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";


const cookie = new Cookies();
const idAdministrativo = cookie.get("idAdministrativo");
const idRolAdministrativo = cookie.get("rol");
let listaauxiliar = [];
const itemsPerPage = 10;



export default class AsignarTutorEstud extends Component {

    constructor(props) {
        super(props)
        this.state = {
            modalDescripcionDocumento: false,
            carrera: [],
            listTiposCalificaciones: [],
            notas: {},
            estud: [],
            EstudianteBackup: [],
            textBuscar: "",
            periodos: [],
            cedulaEstudianteSelect: "",
            estado: "",
            objestudiante: null,
            idPeriodo: "1",
            idCarrera: "1",
            docentes: [],
            listtipotitulacion: [],
            documentoTitulacion: [],
            idEstudianteSelect: '',
            //variables para paginacion
            currentItems: null,
            pageCount: 0,
            itemOffset: 0,
            count: 0,
        }
        this.handleChange = this.handleChange.bind(this);
    }

    handleChange = async (e) => {
        await this.setState({ [e.target.name]: e.target.value })
        this.setState({ estado: "" });
    }

    escFunction(event) {
        if (event.key === "Escape") {
            this.setState({ modalDescripcionDocumento: false });
        }
    }

    componentDidMount() {
        axios
            .get(baseUrlPeriodos, {})
            .then(response => {
                const listaperiodos = response.data.data;
                const cant = listaperiodos.length;
                if (cant != 0) {
                    this.setState({ periodos: listaperiodos });
                }
            })

        axios.get(carrerasUrl)
            .then(res => {
                const carrera = res.data;
                this.setState({ carrera });
            })
        axios.get(urlListaDocentes)
            .then(res => {
                const docentes = res.data.data;
                this.setState({ docentes });
            })
    }

    // handlers
    handleNotaChange = (pivotId, value) => {
        const v = value === '' ? '' : Number(value);
        this.setState(prev => ({ notas: { ...prev.notas, [pivotId]: v } }));
    };

    getPromedio = () => {
        const { listTiposCalificaciones, notas } = this.state;
        const valores = listTiposCalificaciones
            .map(it => notas[it.id_tipo_titulacion_tipo_calificacion])
            .filter(v => typeof v === 'number' && !Number.isNaN(v));
        if (!valores.length) return '';
        const sum = valores.reduce((a, b) => a + b, 0);
        return (sum / valores.length).toFixed(2);
    };

    //BUSQUEDA......
    filter(event) {
        console.log(event.target.value);
        //obtener datos de buscar
        var text = event.target.value
        //obtener datos del array
        const data = this.state.estud
        var newData = data.filter(function (item) {
            //variable del objeto
            const itemDataPrimerApell = item.primer_apellido_estudiante.toUpperCase()
            const itemDataPrimerNom = item.primer_nombre_estudiante.toUpperCase()
            const itemDataCedula = item.numero_identificacion_estudiante.toUpperCase()
            const campo = itemDataPrimerApell + " " + itemDataPrimerNom + " " + itemDataCedula;   //variable del buscador
            const textData = text.toUpperCase()
            return campo.indexOf(textData) > -1
        })
        if (text == "") {
            newData = this.state.EstudianteBackup;
        }
        this.setState({
            currentItems: newData,
            textBuscar: text,
        })

    }


    handleChangeTipoTitulacionCarrera = async (e) => {
        await this.setState({ [e.target.name]: e.target.value });
        axios
            .post(urlListarTiposTitulacion, {
                idCarreraTipoT: this.state.idCarrera
            })
            .then(response => {

                const listatipotitul = response.data.data;
                const cant = listatipotitul.length;
                if (cant != 0) {
                    this.setState({ listtipotitulacion: listatipotitul });
                }
                else {
                    this.setState({ error: "No existe tipos de titulación " });
                    swal({
                        text: "¡No existe tipos de titulación!",
                        icon: "info",
                        button: "Aceptar",
                    });

                }
            })
    }

    handleChangeEstudTipoTitulacion = async (e) => {
        await this.setState({ [e.target.name]: e.target.value });
        axios
            .post(urlListaEstudTipoTitulacion, {
                idCarrera: this.state.idCarrera,
                idPeriodo: this.state.idPeriodo,
                idTipoTitulacion: this.state.idTipoTitulacion,
                idRolAdmin: idRolAdministrativo
            })
            .then(response => {
                if (response.data.success == true) {
                    listaauxiliar = response.data.data;
                    const estud = response.data.data;
                    this.setState((state) => {
                        return { estud: estud }
                    }
                    );
                    const EstudianteBackup = estud;
                    this.setState((state) => {
                        return { EstudianteBackup: EstudianteBackup }
                    });

                    //PAGINACION
                    this.setState({ itemOffset: 0 });
                    const endOffset = this.state.itemOffset + itemsPerPage;
                    this.setState({ currentItems: listaauxiliar.slice(this.state.itemOffset, endOffset) });
                    this.setState({ EstudianteBackup: listaauxiliar.slice(this.state.itemOffset, endOffset) });
                    this.setState({ pageCount: Math.ceil(listaauxiliar.length / itemsPerPage) });
                    this.setState((state) => {
                        return { itemOffset: state.itemOffset + endOffset }
                    });
                    //FIN  DE LA PAGINACION
                    this.setState({ estado: "" });

                } else {
                    const estudiantes = [];
                    this.setState({ estudiantes });
                    this.setState({ estado: "No existe datos para mostrar" });
                    swal({
                        text: "No existe datos para mostrar",
                        icon: "info",
                        button: "Aceptar",
                    });

                }
            })
            .catch(error => {
                const estudiantes = [];
                this.setState({ estudiantes });
                this.setState({ estado: "No existe conexión con el servidor" });
                swal({
                    text: "No existe conexión con el servidor",
                    icon: "error",
                    button: "Aceptar",
                });
            });

    }

    handleChangeTutor = (registro) => {
        //await this.setState({ [e.target.name]: e.target.value });
        var idSelect = "idTutorEstud" + registro.id_estudiante;
        var idTutor = document.getElementById(idSelect).value;
        axios
            .post(urlAsignarTutorestud, {
                idEstud: registro.id_estudiante,
                idPeriodo: this.state.idPeriodo,
                idCarrera: this.state.idCarrera,
                idTutor: idTutor,
            })
            .then(response => {
                if (response.data.success == true) {
                    swal({
                        text: "Se ha asignado un tutor",
                        icon: "success",
                        button: "Aceptar",
                    });
                    //Actualizar la lista
                    axios
                        .post(urlListaEstudTipoTitulacion, {
                            idCarrera: this.state.idCarrera,
                            idPeriodo: this.state.idPeriodo,
                            idTipoTitulacion: this.state.idTipoTitulacion,
                            idRolAdmin: idRolAdministrativo
                        })
                        .then(response => {
                            if (response.data.success == true) {
                                listaauxiliar = response.data.data;
                                const estud = response.data.data;
                                this.setState((state) => {
                                    return { estud: estud }
                                }
                                );
                                const EstudianteBackup = estud;
                                this.setState((state) => {
                                    return { EstudianteBackup: EstudianteBackup }
                                });

                                //PAGINACION
                                this.setState({ itemOffset: 0 });
                                const endOffset = this.state.itemOffset + itemsPerPage;
                                this.setState({ currentItems: listaauxiliar.slice(this.state.itemOffset, endOffset) });
                                this.setState({ EstudianteBackup: listaauxiliar.slice(this.state.itemOffset, endOffset) });
                                this.setState({ pageCount: Math.ceil(listaauxiliar.length / itemsPerPage) });
                                this.setState((state) => {
                                    return { itemOffset: state.itemOffset + endOffset }
                                });
                                //FIN  DE LA PAGINACION
                                this.setState({ estado: "" });

                            } else {
                                const estudiantes = [];
                                this.setState({ estudiantes });
                                this.setState({ estado: "No existe datos para mostrar" });
                                swal({
                                    text: "No existe datos para mostrar",
                                    icon: "info",
                                    button: "Aceptar",
                                });
                            }
                        })
                        .catch(error => {
                            const estudiantes = [];
                            this.setState({ estudiantes });
                            this.setState({ estado: "No existe conexión con el servidor" });
                            swal({
                                text: "No existe conexión con el servidor",
                                icon: "error",
                                button: "Aceptar",
                            });
                        });
                    //Fin de la lista
                }
                else {
                    swal({
                        text: "Datos no registrados",
                        icon: "error",
                        button: "Aceptar",
                    });
                }
            })
    }

    //FUNCION DE PAGINACION POR  MEDIO DE UN CLIC
    handlePageClick = (event) => {
        const newOffset = (event.selected * itemsPerPage) % listaauxiliar.length;
        this.setState((state) => {
            return { itemOffset: newOffset }
        });
        const endOffset = newOffset + itemsPerPage;
        this.setState({ currentItems: listaauxiliar.slice(newOffset, endOffset) });
        this.setState({ EstudianteBackup: listaauxiliar.slice(newOffset, endOffset) });
        this.setState({ pageCount: Math.ceil(listaauxiliar.length / itemsPerPage) });
        this.setState((state) => {
            return { itemOffset: newOffset }
        });
    }
    seleccionarEstudianteuno = async (e, consola) => {
        await this.setState({ [e.target.name]: e.target.value })
        this.setState({ idEstudianteSelect: consola.id_estudiante });
        this.setState({ documentoTitulacion: [] });
        // Actualizar la lista de documentos de los estudiantes
        axios.post(urlReportDocumentoTitulacionEst, {
            idTipoTitul: this.state.idTipoTitulacion,
            idEstudiante: consola.id_estudiante,
            idCarrera: this.state.idCarrera,
        })
            .then(res => {
                const documentoTitulacion = res.data.data;
                this.setState({ documentoTitulacion });
            })
        //Listar los tipos de calificaciones de acuerdo al tipo de titulación
        try {
            const { idTipoTitulacion, idCarrera } = this.state;

            const resp = await axios.get(urlListarTiposCalificacionesHab, {
                params: {
                    idTipoTitulacion,                  // <- desde state
                    idEstudiante: consola.id_estudiante, // <- desde la fila/objeto consola
                    idCarrera,                         // <- desde state
                }
            });

            const ok = resp?.data?.success === true;
            const lista = Array.isArray(resp?.data?.data) ? resp.data.data : [];

            if (!ok || !lista.length) {
                this.setState({ listTiposCalificaciones: [], notas: {}, error: "No existen tipos de calificación" });
                swal({ text: "No existen tipos de calificación", icon: "info", button: "Aceptar" });
                return;
            }

            // Construir mapa de notas por pivot_id
            const notas = {};
            for (const it of lista) {
                const pid = it.id_tipo_titulacion_tipo_calificacion;
                // Si viene null/undefined -> '', si viene número -> lo casteamos
                notas[pid] = (it.nota === null || it.nota === undefined || it.nota === "")
                    ? ""
                    : Number(it.nota);
            }

            this.setState({
                listTiposCalificaciones: lista,
                notas,
                error: null
            });

            // Si quieres inspeccionar:
            // console.log("listTiposCalificaciones:", lista);
            // console.log("notas:", notas);

        } catch (error) {
            console.error("Error al obtener los tipos de calificación:", error);
            this.setState({ listTiposCalificaciones: [], notas: {}, error: "No se encontraron datos" });
            swal({ text: "No se encontraron datos", icon: "error", button: "Aceptar" });
        }

    }

    //Modificar información del documento
    modificarInformacionDocumento = (e, consola) => {
        var idSelectEstadoDoc = "estdocumentitul" + this.state.idEstudianteSelect + "" + consola.id_documento_titulacion;
        var idEstado = document.getElementById(idSelectEstadoDoc).value;
        var idObservcionDoc = "obsdocumentitul" + this.state.idEstudianteSelect + "" + consola.id_documento_titulacion;
        var observacion = document.getElementById(idObservcionDoc).value;
        var idInputFile = "filedocumentitul" + this.state.idEstudianteSelect + consola.id_documento_titulacion;
        var inputFile = document.getElementById(idInputFile);
        var archivo = inputFile?.files[0]; // solo el primer archivo
        var archivoselect = archivo;
        if (archivo) {
            // Validación de tipo de archivo
            const allowedTypes = ['application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'];
            if (!allowedTypes.includes(archivo.type)) {
                swal({
                    text: "El archivo debe ser de tipo PDF o Word (.doc, .docx)",
                    icon: "error",
                    button: "Aceptar",
                });
                return; // Detenemos la ejecución si el archivo no es válido
            }
            //Tomar el valor del select
        } else {
            archivoselect = null;
        }

        var idDocumentoEstud = consola.iddocumentestud;

        const formData = new FormData();
        formData.append("idestadodocument", idEstado);
        formData.append("observaciondoc", observacion);
        formData.append("archivorevisado", archivoselect);
        formData.append("iddocumentoestudiante", idDocumentoEstud);
        const config = {
            headers: { 'Content-Type': 'multipart/form-data' },
        };
        // Enviar la solicitud POST con el archivo
        axios.post(urlRespuestaDocumentos, formData, config)
            .then(response => {
                if (response.data.success) {
                    swal({
                        text: "Información actualizada correctamente",
                        icon: "success",
                        button: "Aceptar",
                    });
                    // Actualizar la lista de documentos de los estudiantes
                    axios.post(urlReportDocumentoTitulacionEst, {
                        idTipoTitul: this.state.idTipoTitulacion,
                        idEstudiante: this.state.idEstudianteSelect,
                        idCarrera: this.state.idCarrera,
                    })
                        .then(res => {
                            const documentoTitulacion = res.data.data;
                            this.setState({ documentoTitulacion });
                        })
                } else {
                    swal({
                        text: response.data.message || "Error al cargar el documento",
                        icon: "error",
                        button: "Aceptar",
                    });
                }
            })
            .catch(error => {
                console.error("Error en la solicitud:", error);
                swal({
                    text: "No se pudo conectar con el servidor",
                    icon: "error",
                    button: "Aceptar",
                });
            });
    }
    mostrarModalDescripDocumento = (registro) => {
        this.setState({
            modalDescripcionDocumento: true,
            descripcionDocumento: registro || ''
        });
    };
    ocultarModalDescripDocumento = () => {
        this.setState({ modalDescripcionDocumento: false });
    }
    handleChangeObservacion = (e, idDocumento) => {
        const nuevaObservacion = e.target.value;
        this.setState((prevState) => ({
            documentoTitulacion: prevState.documentoTitulacion.map((doc) => {
                if (doc.id_documento_titulacion === idDocumento) {
                    return { ...doc, observacion_documento: nuevaObservacion };
                }
                return doc;
            })
        }));
    };
    //Ingresar las calificaciones de titulación 
    ingresarCalificaciones = async () => {
        try {
            const { idEstudianteSelect, idCarreraSelect, listTiposCalificaciones, notas } = this.state;

            // Construir el payload a partir de los inputs controlados
            const payloadNotas = listTiposCalificaciones.map(it => {
                const pid = it.id_tipo_titulacion_tipo_calificacion;
                let v = notas[pid];
                // normaliza vacío/NaN -> 0
                v = (v === '' || v === null || Number.isNaN(Number(v))) ? 0 : Number(v);
                return { pivot_id: Number(pid), nota: v };
            });

            // Validación cliente (rango 0–20; ajusta si tu escala es 0–100)
            const fueraDeRango = payloadNotas.find(n => n.nota < 0 || n.nota > 10);
            if (fueraDeRango) {
                swal({ text: "Hay una nota fuera de rango (0–10).", icon: "warning", button: "Aceptar" });
                return;
            }

            const resp = await axios.post(urlIngresarCalifiTitulaEstudiante, {
                idEstudiante: this.state.idEstudianteSelect,
                idCarrera: this.state.idCarrera,
                notas: payloadNotas,
            });

            if (resp.data?.success) {
                swal({ text: "Notas registradas correctamente.", icon: "success", button: "Aceptar" });
                // (Opcional) recarga los datos para reflejar lo guardado
                // await this.cargarTiposCalificaciones({ id_estudiante: idEstudianteSelect });
            } else {
                throw new Error(resp.data?.message || "No se pudo registrar.");
            }
        } catch (err) {
            const msg = err.response?.data?.message || "No existe conexión con el servidor";
            swal({ text: msg, icon: "error", button: "Aceptar" });
        }
    };

    render() {
        return (

            <div className="row animate__animated animate__fadeIn">
                <ol className="breadcrumb mb-4">
                    <li className="breadcrumb-item active">{ }</li>
                </ol>
                <div className="card shadow p-3 mb-5 bg-white rounded">
                    <div className="back-istmas">
                        <i className="fas fa-graduation-cap icono-animado"></i>
                        <b className="mb-0 fw-semibold"> Estudiantes para el desarrollo del Trabajo de Titulación</b>
                    </div>

                    <div className="card-body">
                        <div class="row">
                            <div className="col-12 col-sm-12 col-lg-1 col-xl-3 " >
                                <div className="mb-3">
                                    <label className="form-label"><b> <i className="fa-magnifying-glass"></i> Buscar:</b></label>
                                    <input type="text" class="form-control col-md-12" value={this.state.text} placeholder="Buscar..." onChange={(text) => this.filter(text)} />
                                </div>
                            </div>
                            <div className="col-12 col-sm-12 col-lg-1 col-xl-3 " >
                                <div className="mb-3">
                                    <label className="form-label"><b> <i className="fa fa-calendar"></i> Período</b></label>
                                    <select className="form-select" name="idPeriodo" value={this.state.value} onChange={this.handleChange} aria-label="Default select example">
                                        <option value="undefined" selected="true" disabled>Seleccione el periódo</option>
                                        {this.state.periodos.map(periodo => <option key={periodo.id_periodo_academico} value={periodo.id_periodo_academico} > {periodo.descripcion_periodo_academico}</option>)}
                                    </select>
                                </div>
                            </div>
                            <div className="col-12 col-sm-12 col-lg-1 col-xl-3 " >
                                <div className="mb-3">

                                    <label className="form-label"><b>Carrera</b></label>
                                    <select className="form-select" id="idCarrera" name="idCarrera" value={this.state.value} onChange={this.handleChangeTipoTitulacionCarrera} aria-label="Default select example">
                                        <option value="undefined" selected="true" disabled>Seleccione una carrera</option>
                                        {this.state.carrera.map(person => <option key={person.id_carrera} value={person.id_carrera} > {person.descripcion_carrera}</option>)}
                                    </select>

                                </div>
                            </div>
                            <div className="col-12 col-sm-12 col-lg-1 col-xl-3 " >
                                <div className="mb-3">
                                    <label className="form-label"><b>Tipos titulación</b></label>
                                    <select className="form-select" name="idTipoTitulacion" value={this.state.value} onChange={this.handleChangeEstudTipoTitulacion} aria-label="Default select example">
                                        <option value="undefined" selected="true" disabled>Seleccione un tipo titulación</option>
                                        {this.state.listtipotitulacion.map(person => <option key={person.id_tipo_titulacion} value={person.id_tipo_titulacion} > {person.nom_tipo_titulacion}</option>)}
                                    </select>
                                </div>
                            </div>

                            <div className="col-12 col-sm-12 col-lg-1 col-xl-3 ">
                            </div>
                        </div>

                        <div className="row ">

                            <div className="p-3 rounded-3 mt-3">
                                <h6 className="fw-bold text-center mb-3 text-azul">Reporte de estudiantes</h6>

                                <div class="table-responsive">
                                    <table className="table table-hover table-sm-custom" >
                                        <thead className="table-light">
                                            <tr className="text-start text-azul" >
                                                <th scope="col">Cédula</th>
                                                <th scope="col">Primer Apellido</th>
                                                <th scope="col">Segundo Apellido</th>
                                                <th scope="col">Primer Nombre</th>
                                                <th scope="col">Segundo Nombre</th>
                                                <th scope="col">Tutor</th>
                                                <th scope="col">Estado</th>
                                                <th scope="col">Seleccionar</th>

                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.state.currentItems &&
                                                this.state.currentItems.map((consola) => (
                                                    <tr className="text-start text-azul" class="list-afiliados" key={this.state.estud.id_estudiante}  >
                                                        <td >{consola.numero_identificacion_estudiante}
                                                        </td>
                                                        <td >{consola.primer_apellido_estudiante}</td>
                                                        <td>{consola.segundo_apellido_estudiante}</td>
                                                        <td>{consola.primer_nombre_estudiante}</td>
                                                        <td>{consola.segundo_nombre_estudiante}</td>
                                                        <td>
                                                            <select className="form-select" name={"idTutorEstud" + consola.id_estudiante} id={"idTutorEstud" + consola.id_estudiante} value={this.state.value} onChange={() => this.handleChangeTutor(consola)} aria-label="Default select example">
                                                                <option value="undefined" selected="true" disabled>Seleccione un tutor</option>
                                                                {this.state.docentes.map(person => <option key={person.id_administrativo} value={person.id_administrativo} > {person.apellidos_administrativo + " " + person.nombres_administrativo}</option>)}
                                                            </select>
                                                            {(() => {
                                                                $(function () {
                                                                    if (consola.administrativos_id_administrativo != 1) {
                                                                        $("#idTutorEstud" + consola.id_estudiante).val(consola.administrativos_id_administrativo);
                                                                    } else {
                                                                        $("#idTutorEstud" + consola.id_estudiante).val("undefined");
                                                                    }
                                                                });
                                                            })()}

                                                        </td>
                                                        <td>
                                                            {(() => {
                                                                if (consola.estado_general == 1) {
                                                                    return <span className="badge bg-success text-white small rounded-pill">Procesar</span>;
                                                                } else if (consola.estado_general == 2) {
                                                                    return <span className="badge bg-warning text-white small rounded-pill">Procesar</span>;
                                                                }

                                                            })()}
                                                        </td>
                                                        <td>
                                                            <input type="radio" value="1" name="interfazdocument" onChange={(e) => this.seleccionarEstudianteuno(e, consola)}
                                                            />
                                                        </td>
                                                    </tr>
                                                ))}
                                        </tbody>
                                    </table>

                                </div>
                                <div className="d-flex justify-content-center mt-4 ">
                                    <ReactPaginate
                                        previousLabel="<"
                                        nextLabel=">"
                                        pageCount={this.state.pageCount}
                                        onPageChange={this.handlePageClick}
                                        containerClassName="pagination pagination-sm-custom"
                                        pageLinkClassName="page-link"
                                        previousClassName="page-item"
                                        previousLinkClassName="page-link"
                                        nextClassName="page-item"
                                        nextLinkClassName="page-link"
                                        activeClassName="active"
                                    />
                                </div>
                            </div>


                        </div>
                        {/* tabla de reporte de documentos estudiante */}
                        <br />
                        <div className="p-3 rounded-3 mt-3">
                            <h6 className="fw-bold text-center mb-3 text-azul">Reporte de documentos</h6>
                            <div class="table-responsive">
                                <table className="table table-hover table-sm-custom" id="tablaasignaturas" name="tablaasignaturas" width="100%" >
                                    <thead className="table-light">
                                        <tr className="text-start text-azul" >
                                            <th class="oculto">ID</th>
                                            <th>No</th>
                                            <th>Nombre</th>
                                            <th>Descripción</th>
                                            <th>Formato</th>
                                            <th>Archivo subido</th>
                                            <th>Fecha de envio</th>
                                            <th class="oculto">CarreraTipoTitulacion</th>
                                            <th >Revisado por</th>
                                            <th >Observaciones</th>
                                            <th >Cargar Archivo</th>
                                            <th>Estado</th>
                                            <th >Responder</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.documentoTitulacion.map((consola) => (
                                            
                                            <tr className="text-start text-azul" key={consola.id_documento_titulacion}>
                                                <td class="oculto">{consola.id_documento_titulacion}</td>
                                                <td>{consola.orden_documento_id}</td>
                                                <td>{consola.nom_documento_titulacion}</td>
                                                <td>
                                                    <button
                                                        onClick={() => this.mostrarModalDescripDocumento(consola.descrip_documento_titulacion)}
                                                        style={{ background: "none", border: "none", padding: 0, cursor: "pointer" }}
                                                    >
                                                        <i className="fa fa-2x fa-align-left text-primary" ></i>
                                                    </button>
                                                </td>
                                                <td>
                                                    {(() => {
                                                        if (consola.archivo_documento_titulacion) {
                                                            return <a href={consola.ruta_formato} target="blank"><i class="fa fa-2x fa-file-alt text-danger" aria-hidden="true"></i></a>
                                                        }
                                                    })()}

                                                </td>
                                                <td>
                                                    {(() => {
                                                        if (consola.iddocumentestud == 0) {

                                                            return <span className="small text-muted">Pendiente</span>
                                                        }
                                                        else {
                                                            if (consola.archivo_documento_titulacion) {
                                                                return (
                                                                    <a href={consola.ruta_document_cargado} target="_blank" rel="noopener noreferrer" title="Descargar el archivo subido">
                                                                        <i class="fa fa-2x fa-file-alt text-success" aria-hidden="true"></i>
                                                                    </a>
                                                                );
                                                            }
                                                        }
                                                    })()}

                                                </td>
                                                <td>
                                                    {consola.fecha_envio}
                                                </td>

                                                <td class="oculto"> {consola.carrera_tipo_titulacion_id}</td>

                                                <td>{consola.descripcion_rol}

                                                </td>
                                                <td>
                                                    <textarea
                                                        name={`obsdocumentitul${this.state.idEstudianteSelect}${consola.id_documento_titulacion}`}
                                                        id={`obsdocumentitul${this.state.idEstudianteSelect}${consola.id_documento_titulacion}`}
                                                        onChange={(e) => this.handleChangeObservacion(e, consola.id_documento_titulacion)}
                                                        className="form-control"
                                                        placeholder=""
                                                        maxLength="500"
                                                        required
                                                        disabled={this.state.isDisabled}
                                                        value={consola.observacion_documento || ''}
                                                    />
                                                </td>
                                                <td class="detalle">
                                                    <input
                                                        type="file"
                                                        accept=".pdf,.doc,.docx"
                                                        id={`filedocumentitul${this.state.idEstudianteSelect}${consola.id_documento_titulacion}`}
                                                        className="form-control form-control-sm"
                                                    />
                                                </td>

                                                <td class="estadodocument">
                                                    <select className="form-select" name={"estdocumentitul" + this.state.idEstudianteSelect + consola.id_documento_titulacion} id={"estdocumentitul" + this.state.idEstudianteSelect + consola.id_documento_titulacion} value={this.state.value} aria-label="Default select example">
                                                        <option value="undefined" selected="true" disabled>Seleccione el estado</option>
                                                        {consola.lista_estad_rol.map(estados => <option key={estados.id_estad_documentos_titulacion} value={estados.id_estad_documentos_titulacion} > {estados.nom_estad_documentos_titulacion}</option>)}

                                                    </select>

                                                    {(() => {
                                                        if (consola.id_estado > 0) {
                                                            var nom = this.state.idEstudianteSelect;
                                                            $(function () {
                                                                var nombrevar = nom + "" + consola.id_documento_titulacion;
                                                                $("#estdocumentitul" + nombrevar).val(consola.id_estado);
                                                            });
                                                        } else {
                                                            var nom = this.state.idEstudianteSelect;
                                                            $(function () {
                                                                var nombrevar = nom + "" + consola.id_documento_titulacion;
                                                                $("#estdocumentitul" + nombrevar).prop('selectedIndex', 0); // o .val('') si usas un value vacío
                                                            });
                                                        }

                                                    })()}


                                                </td>

                                                <td>

                                                    {(() => {
                                                        if (consola.iddocumentestud == 0) {

                                                            return <span className="small text-muted">Pendiente</span>
                                                        }
                                                        else {
                                                            if (consola.id_estado === 1 && consola.id_rol === idRolAdministrativo) {
                                                                return (
                                                                    <button
                                                                        onClick={(e) => this.modificarInformacionDocumento(e, consola)}
                                                                        className="btn btn-sm btn-success rounded-pill"
                                                                    >
                                                                        <i className="fas fa-clipboard-check"></i>
                                                                    </button>
                                                                );
                                                            } else {
                                                                if (consola.id_estado === 1 && consola.id_rol !== idRolAdministrativo) {

                                                                    return (
                                                                        <button
                                                                            onClick={(e) => this.modificarInformacionDocumento(e, consola)}
                                                                            className="btn btn-sm btn-danger rounded-pill" >
                                                                            <i className="fas fa-clipboard-check"></i>
                                                                        </button>
                                                                    );
                                                                }
                                                                else {
                                                                    if (consola.id_estado === 3 && consola.id_rol === idRolAdministrativo) {

                                                                        return (
                                                                            <button
                                                                                onClick={(e) => this.modificarInformacionDocumento(e, consola)}
                                                                                className="btn btn-sm btn-info rounded-pill" >
                                                                                <i className="fas fa-clipboard-check"></i>
                                                                            </button>
                                                                        );
                                                                    }
                                                                    else {
                                                                        if (consola.id_estado === 3 && consola.id_rol !== idRolAdministrativo) {

                                                                            return (
                                                                                <button
                                                                                    onClick={(e) => this.modificarInformacionDocumento(e, consola)}
                                                                                    className="btn btn-sm btn-warning rounded-pill" >
                                                                                    <i className="fas fa-clipboard-check"></i>
                                                                                </button>
                                                                            );
                                                                        }
                                                                        else {
                                                                            return (
                                                                                <button
                                                                                    onClick={(e) => this.modificarInformacionDocumento(e, consola)}
                                                                                    className="btn btn-sm btn-secondary rounded-pill" >
                                                                                    <i className="fas fa-clipboard-check"></i>
                                                                                </button>
                                                                            );
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    })()}

                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                                <div class="card-footer text-muted">
                                    <div className="text-center">

                                    </div>
                                </div>
                            </div>
                        </div>

                        <Modal isOpen={this.state.modalDescripcionDocumento}>
                            <ModalHeader>
                                <h5>Descripción</h5>
                            </ModalHeader>
                            <ModalBody>
                                <div className="mb-3 centrar">
                                    <p className="texto-justificado">{this.state.descripcionDocumento}</p>
                                </div>
                            </ModalBody>
                            <ModalFooter>
                                <button className="btn btn-outline-primary" onClick={this.ocultarModalDescripDocumento}>
                                    Salir
                                </button>
                            </ModalFooter>
                        </Modal>
                        {/* tabla de reporte de calificaciones del estudiante*/}
                        <div className="p-3 rounded-3 mt-3">
                            <h6 className="fw-bold text-center mb-3 text-azul">Reporte de calificaciones</h6>

                            <div className="table-responsive mt-4">
                                <table className="table table-sm table-hover align-middle">
                                    <thead className="small text-center table-light">
                                        <tr className="align-middle">
                                            <th className="text-start text-azul">Calificación</th>
                                            <th className="text-start text-azul">Nota</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.listTiposCalificaciones.map(item => {
                                            const pid = item.id_tipo_titulacion_tipo_calificacion;
                                            return (
                                                <tr key={pid}>
                                                    <td className="text-azul small">{item.nombre_calif_doc_titu}</td>
                                                    <td style={{ maxWidth: 140 }}>
                                                        <input
                                                            type="number"
                                                            className="form-control form-control-sm"
                                                            min="0"
                                                            max="20"      // ajusta si tu escala es 0–100
                                                            step="0.01"
                                                            value={this.state.notas[pid] ?? ''}
                                                            onChange={(e) => this.handleNotaChange(pid, e.target.value)}
                                                        />
                                                    </td>
                                                </tr>
                                            );
                                        })}

                                        {/* Fila de PROMEDIO (se actualiza sola) */}
                                        <tr className="table-light">
                                            <td className="text-end fw-bold">Promedio</td>
                                            <td>
                                                <input
                                                    type="text"
                                                    className="form-control form-control-sm fw-bold"
                                                    value={this.getPromedio()}
                                                    readOnly
                                                />
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className="text-center mt-3">
                            <button
                                id="agregar"
                                type="button"
                                className="btn btn-sm btn-primary fw-semibold px-3 py-1 shadow-sm"
                                style={{ borderRadius: "8px", fontSize: "0.85rem" }}
                                onClick={() => this.ingresarCalificaciones()}
                            >
                                <i className="fas fa-plus me-1"></i>Registrar
                            </button>
                        </div>
                        {/* fIN DE ESCONDIDOS */}
                        <br />
                        <div className="alert alert-warning" role="alert" hidden={this.state.hidden}>
                            {this.state.estado}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
